import React from 'react'
import { func, number, node } from 'prop-types'

import Cancel from 'components/atoms/SVGIcons/Cancel'

const Popup = ({ close, children, top }) => (
  <>
    <div className="popup">
      <div className="popup-inner">
        <div className="popup-close" onClick={() => close()}>
          <Cancel />
        </div>
        {children}
      </div>
    </div>
    <style jsx>
      {`
        .popup {
          position: absolute;
          width: 100%;
          height: 100%;
          z-index: 100;
          top: ${top || 0}px;
          right: 0;
          overflow: auto;

          &-inner {
            background-color: #fff;
            padding: 24px;
            height: 100%;
          }
          &-close {
            width: 40px;
            height: 40px;
            box-shadow: 0 2px 8px 0 rgba(26, 52, 79, 0.4);
            background-color: #fff;
            border-radius: 20px;
            float: right;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          @media screen and (min-width: 768px) {
            &-inner {
              padding: 40px;
            }
          }
        }
      `}
    </style>
  </>
)

Popup.propTypes = {
  close: func,
  children: node,
  top: number,
}

export default Popup
